// Pure: the storm's loudness from what the writer is doing. Each input only ever raises it
// (monotonic), word-count escalation saturates (capped curve), and the total never exceeds
// CEILING so the storm can't overwhelm the page.
export const CEILING = 0.95;
const W_SCROLL = 0.5;
const W_WORDS = 0.25;
const W_RHYTHM = 0.18;

const finite = (n: number) => (Number.isFinite(n) ? n : 0);
const clamp = (n: number, lo: number, hi: number) => (n < lo ? lo : n > hi ? hi : n);

export function wordsCurve(words: number): number {
  const w = Math.max(0, finite(words));
  return W_WORDS * (1 - Math.exp(-w / 250));
}

export function composeIntensity(i: { floor: number; scroll: number; words: number; rhythm: number }): number {
  const floor = clamp(finite(i.floor), 0, 1);
  const scroll = clamp(finite(i.scroll), 0, 1);
  const rhythm = clamp(finite(i.rhythm), 0, 1);
  return clamp(floor + scroll * W_SCROLL + wordsCurve(i.words) + rhythm * W_RHYTHM, 0, CEILING);
}
